import React, { useState, useEffect } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { api } from '../../../Api';

export default function FaqCategoriesModal({ handleClose, faqcategory, refreshAdmin }) {
  const [loading, setloading] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [name, setname] = useState('');

  function Savefaqcategory() {
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();

    faqcategory && formdata.append('id', faqcategory?.id);
    formdata.append('name', name);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    setloading(true);

    fetch(faqcategory ? api.edit_faq_category : api.add_faq_category, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.text();
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then((result) => {
        const response = JSON.parse(result);
        refreshAdmin();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }

  useEffect(() => {
    if (faqcategory) {
      setname(faqcategory?.name);
    }
  }, []);

  return (
    <Box
      p={1}
      mt={2}
      style={{
        width: '100%',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {faqcategory ? 'Edit FAQ Category' : 'FAQ Category'}
      </Typography>

      <Box display={'flex'} sx={{ width: '90%', my: 4, flexDirection: 'column' }}>
        <TextField
          id="outlined-error-helper-text"
          fullWidth
          label="Faq Category Name"
          value={name}
          onChange={(val) => {
            setname(val.target.value);
          }}
          type="text"
          variant="outlined"
          display="inline"
        />

        <Box mt={2}></Box>
        {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '90%'
        }}
      >
        <LoadingButton
          disabled={false}
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={Savefaqcategory}
          color="primary"
          variant="contained"
        >
          Save
        </LoadingButton>
        <LoadingButton onClick={handleClose} variant="outlined">
          Close
        </LoadingButton>
      </Box>
    </Box>
  );
}
